module.exports = __webpack_public_path__ + "static/media/light_dataak_headlogo.15599296.svg";